import React, { useEffect, useState, Fragment } from 'react';
import { ChevronRight, ShoppingCart, Trash2, Minus, Plus, Tag, ArrowLeft } from 'lucide-react';
const STEPS = [{
  number: 1,
  label: 'Sign In'
}, {
  number: 2,
  label: 'Address'
}, {
  number: 3,
  label: 'Shipping'
}, {
  number: 4,
  label: 'Payment'
}, {
  number: 5,
  label: 'Invoice'
}];
export function CheckoutPage() {
  const [discountOpen, setDiscountOpen] = useState(false);
  const [discountCode, setDiscountCode] = useState('');
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const currentStep = 1;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="bg-cream" data-id="element-146">
      {/* Page Header */}
      <div className="bg-cream-dark border-b border-warmBorder" data-id="element-147">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-148">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-149">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-150">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-151" />
            <span className="text-charcoal font-medium" data-id="element-152">Checkout</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-153">
            Checkout
          </h1>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-154">
        {/* Step Indicator */}
        <div className="mb-12" data-id="element-155">
          <div className="flex items-center justify-between max-w-2xl mx-auto" data-id="element-156">
            {STEPS.map((step, idx) => <Fragment key={step.number} data-id="element-157">
                <div className="flex items-center gap-2" data-id="element-158">
                  <span className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${step.number === currentStep ? 'bg-gold text-white' : step.number < currentStep ? 'bg-sage text-white' : 'bg-warmBorder text-warmGray'}`} data-id="element-159">
                    {step.number}
                  </span>
                  <span className={`text-sm font-medium hidden sm:inline ${step.number === currentStep ? 'text-charcoal font-bold' : 'text-warmGray'}`} data-id="element-160">
                    {step.label}
                  </span>
                </div>
                {idx < STEPS.length - 1 && <div className="flex-1 h-px bg-warmBorder mx-2 sm:mx-4" data-id="element-161" />}
              </Fragment>)}
          </div>
        </div>

        {/* Cart Contents */}
        <div className="bg-white rounded-sm border border-warmBorder shadow-sm mb-8" data-id="element-162">
          {/* Empty Cart State */}
          <div className="p-8 md:p-10 text-center" data-id="element-163">
            <div className="w-16 h-16 mx-auto bg-cream-dark rounded-full flex items-center justify-center mb-5" data-id="element-164">
              <ShoppingCart className="w-8 h-8 text-warmGray" data-id="element-165" />
            </div>
            <h2 className="text-xl font-serif text-charcoal mb-2" data-id="element-166">
              Your Cart is Empty
            </h2>
            <p className="text-warmGray mb-6" data-id="element-167">
              Browse our collection to find the perfect switchplates for your
              home.
            </p>
            <a href="#/" className="inline-flex items-center gap-2 px-8 py-3.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm uppercase tracking-wider" data-id="element-168">
              <ArrowLeft size={16} data-id="element-169" />
              Continue Shopping
            </a>
          </div>

          {/* Order Summary */}
          <div className="border-t border-warmBorder px-8 md:px-10 py-6" data-id="element-170">
            {/* Discount Code */}
            <div className="mb-6" data-id="element-171">
              {!discountOpen ? <button onClick={() => setDiscountOpen(true)} className="flex items-center gap-2 text-gold hover:text-gold-dark font-bold text-sm transition-colors" data-id="element-172">
                  <Tag size={16} data-id="element-173" />
                  Have a Discount Code?
                </button> : <div className="flex gap-3 max-w-sm" data-id="element-174">
                  <input type="text" value={discountCode} onChange={e => setDiscountCode(e.target.value)} placeholder="Enter discount code" className="flex-1 px-4 py-2.5 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all text-sm" data-id="element-175" />
                  <button className="px-5 py-2.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm" data-id="element-176">
                    Apply
                  </button>
                </div>}
            </div>

            {/* Totals */}
            <div className="space-y-2 text-sm max-w-xs ml-auto" data-id="element-177">
              <div className="flex justify-between" data-id="element-178">
                <span className="text-warmGray" data-id="element-179">Subtotal</span>
                <span className="font-bold text-charcoal" data-id="element-180">$0.00</span>
              </div>
              <div className="flex justify-between" data-id="element-181">
                <span className="text-warmGray" data-id="element-182">Estimated Shipping</span>
                <button className="text-gold hover:text-gold-dark font-bold text-sm transition-colors" data-id="element-183">
                  Calculate
                </button>
              </div>
              <div className="flex justify-between pt-3 border-t border-warmBorder" data-id="element-184">
                <span className="font-bold text-charcoal text-base" data-id="element-185">TOTAL</span>
                <span className="font-bold text-charcoal text-base" data-id="element-186">$0.00</span>
              </div>
            </div>
          </div>
        </div>

        {/* Continue Shopping */}
        <div className="text-center mb-12" data-id="element-187">
          <a href="#/" className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-warmBorder text-charcoal hover:border-gold hover:text-gold font-bold rounded-sm transition-colors text-sm" data-id="element-188">
            <ArrowLeft size={16} data-id="element-189" />
            Continue Shopping
          </a>
        </div>

        {/* New / Returning Customer */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-190">
          {/* New Customer */}
          <div className="bg-white p-8 md:p-10 rounded-sm border border-warmBorder shadow-sm" data-id="element-191">
            <h3 className="text-xl font-serif text-charcoal mb-4" data-id="element-192">
              New Customer
            </h3>
            <p className="text-warmGray leading-relaxed mb-8" data-id="element-193">
              If you are a new customer and do not yet have an account on our
              site, please Checkout to continue. You may choose to create an
              account later in the purchase process.
            </p>
            <button className="px-8 py-3.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm uppercase tracking-wider" data-id="element-194">
              Checkout
            </button>
          </div>

          {/* Returning Customer */}
          <div className="bg-white p-8 md:p-10 rounded-sm border border-warmBorder shadow-sm" data-id="element-195">
            <h3 className="text-xl font-serif text-charcoal mb-4" data-id="element-196">
              Returning Customer
            </h3>
            <p className="text-warmGray leading-relaxed mb-6" data-id="element-197">
              If you already have an account, please log in.
            </p>
            <form onSubmit={e => e.preventDefault()} className="space-y-4" data-id="element-198">
              <div data-id="element-199">
                <label htmlFor="login-email" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-200">
                  Email Address
                </label>
                <input type="email" id="login-email" value={loginEmail} onChange={e => setLoginEmail(e.target.value)} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="your@email.com" data-id="element-201" />
              </div>
              <div data-id="element-202">
                <label htmlFor="login-password" className="block text-sm font-bold text-charcoal mb-1.5" data-id="element-203">
                  Password
                </label>
                <input type="password" id="login-password" value={loginPassword} onChange={e => setLoginPassword(e.target.value)} className="w-full px-4 py-3 border border-warmBorder rounded-sm bg-white text-charcoal placeholder-warmGray/60 focus:outline-none focus:ring-2 focus:ring-gold/50 focus:border-gold transition-all" placeholder="••••••••" data-id="element-204" />
              </div>
              <div className="flex items-center gap-4 pt-2" data-id="element-205">
                <button type="submit" className="px-8 py-3.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm uppercase tracking-wider" data-id="element-206">
                  Log In
                </button>
                <a href="#/forgot-password" className="text-gold hover:text-gold-dark font-bold text-sm transition-colors" data-id="element-207">
                  Forgot Password?
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>;
}